import App from "@/App.vue";

export default [
  {
    path: "/endossos",
    name: "request endorsement",
    component: App,
    redirect: { name: "list request endorsement" },
    children: [
      {
        path: "",
        name: "list request endorsement",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/EndorsementList.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Endossos",
              disabled: false,
              link: false,
              to: { name: "request endorsement" }
            }
          ],
          displayName: "Lista Endossos - Lockton",
          requiresAuth: true
        }
      },
      {
        path: "novo_endosso/:id",
        name: "new request endorsement",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewEndorsement.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Novo Endosso",
              disabled: false,
              link: true,
              to: { name: "request endorsement" }
            }
          ],
          displayName: "Novo Endosso - Lockton",
          requiresAuth: true
        }
      },
      {
        path: "nova_requisicao_endosso/:id",
        name: "new request endorsement request",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/NewRequestEndorsement.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Nova Requisição Endosso",
              disabled: false,
              link: true,
              to: { name: "request endorsement" }
            }
          ],
          displayName: "Nova Requisição Endosso - Lockton",
          requiresAuth: true
        }
      }
    ]
  }
];
